import React, {
    Dispatch,
    ReactNode,
    SetStateAction,
    createContext,
    useContext,
    useState,
} from 'react';

interface ILoaderProviderProps {
    children: ReactNode;
}

interface ILoaderValue {
    setShouldRenderLoader: Dispatch<SetStateAction<boolean>>;
    shouldRenderLoader: boolean;
}

const LoaderContext = createContext<ILoaderValue>({
    setShouldRenderLoader: () => {},
    shouldRenderLoader: false,
});

/**
 * the AcquisitionsLoader renders on submit and validation has passed
 */
export default function LoaderProvider({ children }: ILoaderProviderProps) {
    const [shouldRenderLoader, setShouldRenderLoader] =
        useState<boolean>(false);

    return (
        <LoaderContext.Provider
            value={{
                setShouldRenderLoader,
                shouldRenderLoader,
            }}
        >
            {children}
        </LoaderContext.Provider>
    );
}

export const useLoader = () => useContext(LoaderContext);
